import { render } from "./ProfessionalDetails.vue?vue&type=template&id=79c27024&scoped=true"
import script from "./ProfessionalDetails.vue?vue&type=script&lang=js"
export * from "./ProfessionalDetails.vue?vue&type=script&lang=js"

import "./ProfessionalDetails.vue?vue&type=style&index=0&id=79c27024&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c27024"]])

export default __exports__